export const STATION_ROUTE_WAYPOINT_TOOLBAR_E2E =
  "station-route-waypoint-toolbar";

/** Matches MapLibre `.maplibregl-ctrl-group button` (29px) so it aligns with zoom. */
export const STATION_ROUTE_WAYPOINT_MAP_BTN_SIZE_PX = 29;

/** Slightly larger than MapLibre default glyph so the AltRoute icon reads clearly. */
export const STATION_ROUTE_WAYPOINT_MAP_ICON_SIZE_PX = 20;

/**
 * MapLibre top-left controls use 10px margin between groups; pull the waypoint
 * control closer to zoom so it sits higher in the stack.
 */
export const STATION_ROUTE_WAYPOINT_MAP_CTRL_MARGIN_TOP_PX = 5;

export const STATION_ROUTE_WAYPOINT_POPPER_OFFSET_X = 2;

/** Scrollable cap for the insert-on-segment radio list in the add-waypoint popper. */
export const STATION_ROUTE_WAYPOINT_SEGMENT_OPTIONS_MAX_HEIGHT_PX = 330;

export const STATION_ROUTE_WAYPOINT_PENDING_ICON_SIZE_PX = 18;

export const STATION_ROUTE_WAYPOINT_PENDING_ICON_ANCHOR_PX = 9;
